import React from 'react'
import Select from 'react-select'
import fr from 'date-fns/locale/fr'
import DatePicker, { registerLocale } from 'react-datepicker'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Navigate } from 'react-router-dom'

import { Button, Typography, Wrapper } from '../../components/globals'
import { DATE_FORMAT } from '../../../infrastructure/enums/dateFormat.enums'
import { IPowerPlantSelectOption } from '../../../domain/downloads.types'
import {
  CenterWrapper,
  DownloadDatePickerStyles,
  DownloadSubmitButtonStyles,
  powerPlantSelectCustomStyles,
} from './downloads.styles'
import SystemsSelectBtn from './downloads.systemsSelectBtn'
import { DASHBOARD_URL } from '../../../constants/navigation.constants'
import { useCustomTranslation } from '../../../infrastructure/translation/useCustomTranslation'

import { useDownloads } from '.'

// Register the locale for the date picker
registerLocale('fr', fr)

export const Downloads: React.FC = () => {
  const {
    downloadLoading,
    powerPlantListSorted,
    startDate,
    endDate,
    maxDate,
    powerPlantSystemsOptions,
    selectedPowerPlantSystems,
    isSubmitButtondisabled,
    isDownloading,
    userAccessState,
    handlePowerPlantChange,
    setDateRange,
    setMaxDate,
    handleOnSelectStartDate,
    handleSystemsChange,
    handleOnSubmit,
  } = useDownloads()
  const { t } = useCustomTranslation('common')

  return (
    <>
      {!userAccessState?.downloadPage ? (
        <Navigate to={DASHBOARD_URL} />
      ) : (
        <Wrapper>
          {downloadLoading ? (
            <CenterWrapper>
              <FontAwesomeIcon icon="spinner" spin size="lg" />
              <p>{`${t('collect_download_data')}`}</p>
            </CenterWrapper>
          ) : (
            <Wrapper padding="20px" height="auto" width="100%" direction="column">
              <Wrapper height="auto" width="100%" direction="column">
                <Wrapper marginBottom="40px">
                  <Typography fontSize="27px" fontWeight="bold">
                    {t('download_data')}
                  </Typography>
                </Wrapper>
              </Wrapper>

              <Wrapper height="auto" width="100%" direction="row">
                <Wrapper
                  height="auto"
                  width="70%"
                  minWidth="800px"
                  direction="row"
                  justifyContent="space-between"
                >
                  <Wrapper direction="column">
                    <Typography fontSize="16px" fontWeight="bold">
                      {t('powerplant')}
                    </Typography>
                    <Select
                      placeholder={t('powerplants')}
                      styles={powerPlantSelectCustomStyles}
                      options={powerPlantListSorted}
                      onChange={(powerPlantSelectedOption) =>
                        handlePowerPlantChange(powerPlantSelectedOption as IPowerPlantSelectOption)
                      }
                    />
                  </Wrapper>

                  <Wrapper direction="column">
                    <Typography fontSize="16px" fontWeight="bold">
                      {t('periods')} *
                    </Typography>
                    <DownloadDatePickerStyles>
                      <DatePicker
                        selectsRange
                        startDate={startDate}
                        endDate={endDate}
                        dateFormat={DATE_FORMAT.DATE_FR_NO_TIME_SEPARATE_BY_SLASH}
                        placeholderText={t('date_date')}
                        locale="fr"
                        maxDate={maxDate}
                        onChange={setDateRange}
                        onSelect={(item) => handleOnSelectStartDate(item)}
                        onCalendarClose={() => setMaxDate(new Date())}
                        isClearable
                      />
                    </DownloadDatePickerStyles>
                  </Wrapper>

                  <Wrapper direction="column">
                    <Typography fontSize="16px" fontWeight="bold">
                      {t('system')}
                    </Typography>
                    <SystemsSelectBtn
                      powerPlantSystemsOptions={powerPlantSystemsOptions}
                      handleSystemsChange={handleSystemsChange}
                      selectedPowerPlantSystems={selectedPowerPlantSystems}
                    />
                  </Wrapper>
                </Wrapper>

                <Wrapper height="auto" width="50%" direction="column">
                  <Wrapper alignContent="flex-end" justifyContent="flex-end">
                    <DownloadSubmitButtonStyles>
                      <Button
                        type="button"
                        disabled={isSubmitButtondisabled}
                        className={
                          isSubmitButtondisabled ? 'submit-control-disabled' : 'submit-control'
                        }
                        onClick={handleOnSubmit}
                      >
                        {t('download')}
                      </Button>
                    </DownloadSubmitButtonStyles>
                  </Wrapper>
                </Wrapper>
              </Wrapper>

              {isDownloading && (
                <Wrapper width="100%" justifyContent="center" marginTop="2rem">
                  <Typography fontSize="16px" fontWeight="bold">
                    <FontAwesomeIcon icon="spinner" spin size="lg" />
                    {` ${t('collect_download_data')}...`}
                  </Typography>
                </Wrapper>
              )}
            </Wrapper>
          )}
        </Wrapper>
      )}
    </>
  )
}
